module.exports = __webpack_public_path__ + "static/media/imgPoC2.22005b51.svg";